export const mockPurchaseOrderData = [
  {
    id: 'po-001',
    supplierId: 'sup-001',
    supplierName: 'MedSupplies Inc.',
    itemsOrdered: [
      { itemId: 'inv-001', name: 'Sterile Gloves', quantity: 200, unitCost: 2.5, totalCost: 500 },
      { itemId: 'inv-004', name: 'Surgical Masks', quantity: 50, unitCost: 15.99, totalCost: 799.5 }
    ],
    totalCost: 1299.5,
    orderDate: '2024-04-01',
    expectedDeliveryDate: '2024-04-08',
    receivedDate: null,
    status: 'Pending',
    approvalChain: [
      { approverId: 'user-123', approverName: 'Dr. James Smith', status: 'Approved', timestamp: '2024-04-01T14:32:15' },
      { approverId: 'user-456', approverName: 'Sarah Johnson', status: 'Pending', timestamp: null }
    ],
    costCentre: 'General Supplies',
    department: 'ER',
    notes: 'Urgent order needed for ER supplies'
  },
  {
    id: 'po-002',
    supplierId: 'sup-003',
    supplierName: 'PharmaDist',
    itemsOrdered: [
      { itemId: 'inv-003', name: 'Paracetamol 500mg', quantity: 50, unitCost: 8.75, totalCost: 437.5 },
      { itemId: 'inv-007', name: 'Antibiotic Ointment', quantity: 30, unitCost: 12.25, totalCost: 367.5 }
    ],
    totalCost: 805,
    orderDate: '2024-03-25',
    expectedDeliveryDate: '2024-03-28',
    receivedDate: '2024-03-29',
    status: 'Received',
    approvalChain: [
      { approverId: 'user-123', approverName: 'Dr. James Smith', status: 'Approved', timestamp: '2024-03-24T09:15:32' },
      { approverId: 'user-456', approverName: 'Sarah Johnson', status: 'Approved', timestamp: '2024-03-24T11:42:18' }
    ],
    costCentre: 'Pharmacy',
    department: 'PHARM',
    notes: 'Regular monthly order for pharmacy supplies'
  },
  {
    id: 'po-003',
    supplierId: 'sup-002',
    supplierName: 'Medical Equipment Ltd.',
    itemsOrdered: [{ itemId: 'inv-002', name: 'Blood Pressure Monitor', quantity: 5, unitCost: 150, totalCost: 750 }],
    totalCost: 750,
    orderDate: '2024-04-03',
    expectedDeliveryDate: '2024-04-17',
    receivedDate: null,
    status: 'Approved',
    approvalChain: [
      { approverId: 'user-123', approverName: 'Dr. James Smith', status: 'Approved', timestamp: '2024-04-03T15:22:45' },
      { approverId: 'user-456', approverName: 'Sarah Johnson', status: 'Approved', timestamp: '2024-04-04T08:11:30' }
    ],
    costCentre: 'Cardiology',
    department: 'CARD',
    notes: 'Equipment replacement for Cardiology department'
  },
  {
    id: 'po-004',
    supplierId: 'sup-003',
    supplierName: 'PharmaDist',
    itemsOrdered: [{ itemId: 'inv-005', name: 'Insulin Syringes', quantity: 20, unitCost: 25.5, totalCost: 510 }],
    totalCost: 510,
    orderDate: '2024-04-05',
    expectedDeliveryDate: '2024-04-10',
    receivedDate: null,
    status: 'Draft',
    approvalChain: [],
    costCentre: 'Endocrinology',
    department: 'ENDO',
    notes: 'Monthly order for diabetes clinic'
  },
  {
    id: 'po-005',
    supplierId: 'sup-004',
    supplierName: 'Lab Supplies SA',
    itemsOrdered: [
      { itemId: 'new-item-001', name: 'Blood Collection Tubes', quantity: 500, unitCost: 1.75, totalCost: 875 },
      { itemId: 'new-item-002', name: 'Microscope Slides', quantity: 1000, unitCost: 0.25, totalCost: 250 }
    ],
    totalCost: 1125,
    orderDate: '2024-03-20',
    expectedDeliveryDate: '2024-03-30',
    receivedDate: '2024-03-28',
    status: 'Received',
    approvalChain: [
      { approverId: 'user-123', approverName: 'Dr. James Smith', status: 'Approved', timestamp: '2024-03-20T11:15:27' },
      { approverId: 'user-456', approverName: 'Sarah Johnson', status: 'Approved', timestamp: '2024-03-21T09:33:10' }
    ],
    costCentre: 'Laboratory',
    department: 'LAB',
    notes: 'Regular laboratory supplies'
  }
]

export const inventoryTransactionTypes = [
  { value: 'Purchase', description: 'Items purchased and added to inventory' },
  { value: 'Usage', description: 'Items used for patient care or operations' },
  { value: 'Adjustment', description: 'Inventory count adjustment (+ or -)' },
  { value: 'Transfer', description: 'Items transferred between departments' },
  { value: 'Return', description: 'Items returned to supplier' },
  { value: 'Disposal', description: 'Items disposed due to expiry or damage' }
]

export const mockInventoryTransactions = [
  {
    id: 'trans-001',
    date: '2024-04-01',
    type: 'Purchase',
    itemId: 'inv-001',
    itemName: 'Sterile Gloves',
    quantity: 200,
    previousQuantity: 300,
    newQuantity: 500,
    unitCost: 2.5,
    totalCost: 500,
    reference: 'PO-001',
    notes: 'Regular stock replenishment',
    department: 'ER',
    performedBy: 'John Adams'
  },
  {
    id: 'trans-002',
    date: '2024-04-02',
    type: 'Usage',
    itemId: 'inv-001',
    itemName: 'Sterile Gloves',
    quantity: -25,
    previousQuantity: 500,
    newQuantity: 475,
    unitCost: 2.5,
    totalCost: -62.5,
    reference: 'PAT-1234',
    notes: 'Used for patient procedures',
    department: 'ER',
    performedBy: 'Dr. Sarah Chen'
  },
  {
    id: 'trans-003',
    date: '2024-04-03',
    type: 'Adjustment',
    itemId: 'inv-003',
    itemName: 'Paracetamol 500mg',
    quantity: -5,
    previousQuantity: 125,
    newQuantity: 120,
    unitCost: 8.75,
    totalCost: -43.75,
    reference: 'ADJ-001',
    notes: 'Inventory count adjustment',
    department: 'PHARM',
    performedBy: 'Mark Johnson'
  },
  {
    id: 'trans-004',
    date: '2024-03-29',
    type: 'Purchase',
    itemId: 'inv-003',
    itemName: 'Paracetamol 500mg',
    quantity: 50,
    previousQuantity: 75,
    newQuantity: 125,
    unitCost: 8.75,
    totalCost: 437.5,
    reference: 'PO-002',
    notes: 'Monthly order received',
    department: 'PHARM',
    performedBy: 'John Adams'
  },
  {
    id: 'trans-005',
    date: '2024-03-30',
    type: 'Transfer',
    itemId: 'inv-004',
    itemName: 'Surgical Masks',
    quantity: -20,
    previousQuantity: 95,
    newQuantity: 75,
    unitCost: 15.99,
    totalCost: -319.8,
    reference: 'TRF-001',
    notes: 'Transfer to Cardiology department',
    department: 'ER',
    performedBy: 'Emily Williams'
  }
]
